import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

const container = document.getElementById("root");

// If the page was pre-rendered (has child nodes from the prerender step),
// use hydrateRoot to attach React to the existing DOM.
// Otherwise, use createRoot for a fresh render (normal SPA behavior).
if (container.hasAttribute("data-prerendered")) {
  ReactDOM.hydrateRoot(
    container,
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
} else {
  const root = ReactDOM.createRoot(container);
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
}
